import { render, staticRenderFns } from "./PatientsDashboard.vue?vue&type=template&id=667d6606&scoped=true"
import script from "./PatientsDashboard.vue?vue&type=script&lang=js"
export * from "./PatientsDashboard.vue?vue&type=script&lang=js"
import style0 from "./PatientsDashboard.vue?vue&type=style&index=0&id=667d6606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667d6606",
  null
  
)

export default component.exports